import { flowMax, SimpleUnchangedProps, addStateHandlers } from 'ad-hok'
import { getContextHelpers, toObjectKeys } from 'ad-hok-utils'
import { typedAs } from 'shared/src/utils/typedAs'

interface ProductLinkingContext {
  linkProductId: number | null
  setLinkProductId: (id: number) => void
  clearLinkProductId: () => void
}

export const [
  addProductLinkingContextProviderPrivate,
  addProductLinkingContext,
] = getContextHelpers<ProductLinkingContext>(
  toObjectKeys(['linkProductId', 'setLinkProductId', 'clearLinkProductId'])
)

export const addProductLinkingContextProvider: SimpleUnchangedProps = flowMax(
  addStateHandlers(
    {
      linkProductId: typedAs<number | null>(null),
    },
    {
      setLinkProductId: () => (id: number) => ({
        linkProductId: id,
      }),
      clearLinkProductId: () => () => ({
        linkProductId: null,
      }),
    }
  ),
  addProductLinkingContextProviderPrivate
)
